var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.subgroup ? "cf-node-properties__field-sub-group clearfix" : ""
    },
    [
      _vm._l(_vm.parameters, function(param, index) {
        return [
          _c(
            "div",
            {
              key: index,
              staticClass: "cf-node-properties__field",
              class: _vm.getFieldSize(param.name)
            },
            [
              _c("label", { staticClass: "control-label" }, [
                _c("span", { staticStyle: { "white-space": "pre-line" } }, [
                  _vm._v(_vm._s(_vm.formatLongDisplayNames(param.displayName)))
                ]),
                _vm._v(" "),
                !param.isOptional ? _c("span", [_vm._v("*")]) : _vm._e(),
                _vm._v(" "),
                _c("i", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top",
                      value: param.description,
                      expression: "param.description",
                      modifiers: { top: true }
                    }
                  ],
                  staticClass: "fa fa-question-circle m-l-5",
                  attrs: { "aria-hidden": "true" }
                })
              ]),
              _vm._v(" "),
              param.type === "list"
                ? _c("InputSelect", {
                    attrs: {
                      options: param.values,
                      placeholder: param.defaultValue,
                      required: !param.isOptional,
                      error: _vm.getFieldError(
                        _vm.propertyErrors,
                        `${_vm.parentParameterName}.${param.name}`
                      )
                    },
                    on: { input: _vm.updateValue },
                    model: {
                      value: _vm.valueCopy[param.name],
                      callback: function($$v) {
                        _vm.$set(_vm.valueCopy, param.name, $$v)
                      },
                      expression: "valueCopy[param.name]"
                    }
                  })
                : param.type === "number"
                ? _c("InputNumber", {
                    attrs: {
                      required: !param.isOptional,
                      placeholder: param.defaultValue,
                      error: _vm.getFieldError(
                        _vm.propertyErrors,
                        `${_vm.parentParameterName}.${param.name}`
                      )
                    },
                    on: {
                      input: function($event) {
                        return _vm.inputChange(param.name, $event)
                      }
                    },
                    model: {
                      value: _vm.valueCopy[param.name],
                      callback: function($$v) {
                        _vm.$set(_vm.valueCopy, param.name, $$v)
                      },
                      expression: "valueCopy[param.name]"
                    }
                  })
                : param.type === "string" &&
                  !_vm.isParamCodeFormatted(param.name)
                ? _c("InputText", {
                    attrs: {
                      required: !param.isOptional,
                      placeholder: param.defaultValue,
                      error: _vm.getFieldError(
                        _vm.propertyErrors,
                        `${_vm.parentParameterName}.${param.name}`
                      )
                    },
                    on: {
                      input: function($event) {
                        return _vm.inputChange(param.name, $event)
                      }
                    },
                    model: {
                      value: _vm.valueCopy[param.name],
                      callback: function($$v) {
                        _vm.$set(_vm.valueCopy, param.name, $$v)
                      },
                      expression: "valueCopy[param.name]"
                    }
                  })
                : param.type === "string" &&
                  _vm.isParamCodeFormatted(param.name)
                ? _c("PrismEditor", {
                    attrs: {
                      highlight: _vm.highlighter,
                      "line-mumbers": false
                    },
                    on: { input: _vm.inputChange },
                    model: {
                      value: _vm.valueCopy[param.name],
                      callback: function($$v) {
                        _vm.$set(_vm.valueCopy, param.name, $$v)
                      },
                      expression: "valueCopy[param.name]"
                    }
                  })
                : param.type === "sub_type"
                ? _c(
                    "div",
                    { staticClass: "cf-node-properties__input" },
                    [
                      _c("nzToggle", {
                        on: { input: _vm.updateValue },
                        model: {
                          value: _vm.valueCopy[param.name].isEnabled,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.valueCopy[param.name],
                              "isEnabled",
                              $$v
                            )
                          },
                          expression: "valueCopy[param.name].isEnabled"
                        }
                      })
                    ],
                    1
                  )
                : param.type === "bool"
                ? _c(
                    "div",
                    { staticClass: "cf-node-properties__input" },
                    [
                      _c("nzToggle", {
                        on: { input: _vm.updateValue },
                        model: {
                          value: _vm.valueCopy[param.name],
                          callback: function($$v) {
                            _vm.$set(_vm.valueCopy, param.name, $$v)
                          },
                          expression: "valueCopy[param.name]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          param.type === "sub_type" && _vm.valueCopy[param.name].isEnabled
            ? [
                _c("SubTypeProps", {
                  key: `subType-${index}`,
                  attrs: {
                    parameters: param.parameters,
                    "property-errors": _vm.propertyErrors
                  },
                  on: { input: _vm.inputChange },
                  model: {
                    value: _vm.valueCopy[param.name],
                    callback: function($$v) {
                      _vm.$set(_vm.valueCopy, param.name, $$v)
                    },
                    expression: "valueCopy[param.name]"
                  }
                })
              ]
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }